import {coreApi} from "../client";
import { PAYROLL } from "../endpoints";
import { clearAccountsCache } from "./common.service";

export const getWageAndPayTypes = async () => {
  const res = await coreApi.get(PAYROLL.WAGE_TYPES);
  return res.data?.WageAndPayTypeList || [];
};

export const addJobTitle = async (payload) => {
  const res = await coreApi.post(PAYROLL.SAVE_JOB_TITLE, payload);
  return res.data;
};

export const savePayrollSetup = async (payload) => {
  const res = await coreApi.post(PAYROLL.PAYROLL_SETUP, payload);
  return res.data;
};

export const getPayrollSetupById = async (id) => {
  const res = await coreApi.get(PAYROLL.PAYROLL_BY_ID, {
    params: { payrollItemId: id },
  });
  return res.data;
};

export const getFilteredPayrollLoad = async (payload) => {
  const res = await coreApi.post(PAYROLL.FILTERED_PAYROLL, payload);
  return res.data;
}

export const deletePayrollSetup = async (id) => {
  const res = await coreApi.post(
    `${PAYROLL.DELETE_PAYROLL}?PayrollItemId=${id}`
  );
  return res.data;
};

export const clonePayrollSetup = async (payload) => {
  const res = await coreApi.post(PAYROLL.CLONE_PAYROLL, payload);
  return res.data;
};

export const importPayrollSetup = async (payload) => {
  const res = await coreApi.post(PAYROLL.IMPORT_PAYROLL, payload);
  return res.data;
};

export const getPayrollAuditLog = async (payrollItemId) => {
    const res = await coreApi.get(PAYROLL.AUDIT_LOG, {
      params: { payrollItemId },
    });
    return res.data;
};

export const getPrivileges = async (payload) => {
  const res = await coreApi.post(PAYROLL.PRIVILEGES, payload);
  return res.data;
};

export const getAccountTypes = async () => {
  const res = await coreApi.get(PAYROLL.ACCOUNT_TYPES);
  return res.data || [];
};

export const saveAccount = async (payload) => {
  const res = await coreApi.post(PAYROLL.SAVE_ACCOUNT, payload);
  if (res.data?.StatusCode === 200 || res.data?.statusCode === 200) {
    clearAccountsCache(payload?.CorpID || payload?.corpId);
  }
  return res.data;
};